import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Endereco } from './../../modelos/endereco';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-editar-endereco',
  templateUrl: './editar-endereco.component.html',
  styleUrls: ['./editar-endereco.component.css']
})
export class EditarEnderecoComponent implements OnInit {

  @Input() endereco: Endereco;

  @Input() index: number;

  @Output() enderecoEvent: EventEmitter<Endereco>;

  public enderecoCopy: Endereco;

  constructor(private modalService: NgbModal) {
    this.enderecoEvent = new EventEmitter<Endereco>();
  }

  editar(content) {
    this.enderecoCopy = new Endereco(this.endereco);
	const ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false,
		windowClass: 'modalEndereco',
		size: 'lg'
	};
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
	  this.endereco = this.enderecoCopy;
	  this.enderecoCopy.index = this.index;
      this.enderecoEvent.emit(this.enderecoCopy);
    }, (reason) => {
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/editar-endereco/editar-endereco.component.ts